import { calcDateTime, endOfDateTime, isBeforeDateTime, startOfDateTime } from '@occc-app/lib/date';
import { GeneralSurveyFragment } from '@occc/graphql';

import { MAX_DATE_RANGE_DAYS } from '../../constants';

/**
 * Latest date selectable in the Survey Metrics custom date filter.
 * Bounded by the survey's End Date; ongoing surveys (no end date) return
 * `undefined` so the picker falls back to "today" via `disableFuture`.
 */
export const getMetricsFilterMaxSelectableDate = (
  survey?: GeneralSurveyFragment,
): Date | undefined => {
  if (!survey?.configuration.endDate) {
    return undefined;
  }

  return endOfDateTime(new Date(survey.configuration.endDate), 'day');
};

/**
 * Earliest date selectable in the Survey Metrics custom date filter.
 * Bounded by the survey's Start Date, but floored at the max allowed range
 * window so the resulting range can never exceed what the metrics API accepts.
 */
export const getMetricsFilterMinSelectableDate = (
  survey?: GeneralSurveyFragment,
  maxSelectableDate?: Date,
): Date | undefined => {
  if (!survey) {
    return undefined;
  }

  const surveyStartDate = startOfDateTime(new Date(survey.configuration.startDate), 'day');
  const maxDateRangeEarliestSelectableDate = startOfDateTime(
    calcDateTime(maxSelectableDate ?? new Date(), 'sub', MAX_DATE_RANGE_DAYS, 'day'),
    'day',
  );

  return isBeforeDateTime(surveyStartDate, maxDateRangeEarliestSelectableDate)
    ? maxDateRangeEarliestSelectableDate
    : surveyStartDate;
};
